import pinboardImage from '../../assets/images/setupIntentPinboard.png'
import pinboardImage2x from '../../assets/images/setupIntentPinboard@2x.png'

interface PinboardIconProps {
  size?: number
  className?: string
}

/**
 * Pinnwand mit Zetteln über der Setup-Seite „Wobei soll dir HappyTask helfen?“
 * (thiings.co, lizenziert; 25.09.2026). Dekorativ, `alt` bleibt leer.
 */
export const PinboardIcon = ({ size = 100, className = '' }: PinboardIconProps) => (
  <img
    src={pinboardImage}
    srcSet={`${pinboardImage} 1x, ${pinboardImage2x} 2x`}
    alt=""
    width={size}
    height={size}
    className={className}
  />
)
